import { Injectable } from '@angular/core';
import { CashBalanceFieldNames, CashBalanceFieldLabels } from '../cash-balance-field-identifiers'

@Injectable()
export class CashBalanceLabelService {

  constructor() { }

  getLabelTextForField(fieldName: string): string {
    switch (fieldName) {
    case CashBalanceFieldNames.SubLedgerField:
    {
      return CashBalanceFieldLabels.SubLedgerField;
    }
    case CashBalanceFieldNames.PropertyField:
    {
      return CashBalanceFieldLabels.PropertyField;
    }
    default:
    {
      return fieldName;
    }
    }
  }

}
